import React from 'react';
import PropTypes from 'prop-types';
import { useWdTitleStyles } from './styles';
import Grid from '@material-ui/core/Grid';
import SelectedValuesCardInRow from './../../WdValidator/SelectedValuesCardInRow/SelectedValuesCardInRow';

const WdTitle = () => {
	const classes = useWdTitleStyles();
	return (
		<Grid classes={classes}>
			<span className={classes.span}>
				<SelectedValuesCardInRow />
			</span>
		</Grid>
	);
};

WdTitle.propTypes = {
	applicationOriented: PropTypes.bool.isRequired
};

export default WdTitle;
